import React from 'react';
import ReactDOM from 'react-dom/client';
import initDatadogRum from 'datadog/rum';
import initDatadogLogs from 'datadog/logs';
import { isProdEnv } from 'utils/isDevEnv';
import { session } from 'session';
import App from './App';
import './index.css';
import './i18n';

if (isProdEnv()) {
  // Initialize RUM before Logs and before render so logs get the RUM session/view context
  initDatadogRum();
  // Initialize Datadog logs only in production environments
  initDatadogLogs();
}

// Before the first render, so route guards already see a token back from the PSD2 bank
session.restoreAfterExternalRedirect();
session.resolveMode();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
